import { all, AllEffect, ForkEffect } from "redux-saga/effects";
import storeSaga from "./store/saga";
import promoSaga from "./promo/saga";
import orderSaga from "./order/saga";
import menuSaga from "./menu/saga";
import checkoutSaga from "./checkout/saga";
import registrationSaga from "./registration/saga";
import loginSaga from "./auth/saga";
import userSaga from "./user/saga";
import favouriteSaga from "./favourite/saga";
import cartSaga from "./cart/saga";
import loyaltySaga from "./loyalty/saga";
import socialSaga from "./social/saga";
import dashboardSaga from "./dashboard/saga";
import upsellSaga from "./upsell/saga";
import notificationsCenterSaga from "./notificationsCenter/saga";
import errorSaga from "./error/saga";

export default function* rootSaga(): Generator<
  AllEffect<ForkEffect<void>>,
  void,
  unknown
> {
  try {
    yield all([
      ...storeSaga,
      ...promoSaga,
      ...orderSaga,
      ...menuSaga,
      ...checkoutSaga,
      ...registrationSaga,
      ...loginSaga,
      ...userSaga,
      ...favouriteSaga,
      ...cartSaga,
      ...loyaltySaga,
      ...socialSaga,
      ...dashboardSaga,
      ...upsellSaga,
      ...notificationsCenterSaga,
      ...errorSaga,
    ]);
  } catch (err) {
    console.log("error caught in rootsaga", err);
  }
}
